import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { coarseRoutePath, incrementUiMetric } from "../utils/sentry";

/**
 * Emits low-cardinality route metrics for Sentry Metrics (ui.route_view).
 */
export default function SentryRouteMetrics() {
  const location = useLocation();

  useEffect(() => {
    incrementUiMetric("ui.route_view", 1, {
      route: coarseRoutePath(location.pathname),
    });
  }, [location.pathname]);

  return null;
}
